import React from 'react'
import './style.css'
import { Icon } from '@iconify/react/dist/iconify.js'

const SectionCard = ({ title, icon, children, className = '' }) => {
    return (
        <div className={`edit-section-card ${className}`}>
            <div className="edit-section-header">
                {icon && <Icon icon={icon} className="section-icon" />}
                <h2 className="section-title">{title}</h2>
            </div>
            <div className="edit-section-content">
                {children}
            </div>
        </div>
    )
}

export default SectionCard

